import { MouseEvent, useState } from 'react';

import { Menu, MenuItem, MenuOption } from 'libs/ui';

import { IconStyled, Pressedtyled } from './MoreMenu.styles';

interface Props<T extends string | number> {
  options: MenuOption<T>[];
  variant?: 'horizontal' | 'vertical';
  onClickOption: (option: MenuItem<T>) => void;
}

export const MoreMenu = <T extends string | number>({
  options,
  variant = 'vertical',
  onClickOption,
}: Props<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOption = (option: MenuItem<T>) => {
    onClickOption(option);
    handleClose();
  };

  return (
    <>
      <Pressedtyled onClick={handleClick}>
        <IconStyled size={24} variant={variant} />
      </Pressedtyled>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        isOpen={isOpen}
        options={options}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClickOption={handleClickOption}
        onClose={handleClose}
      />
    </>
  );
};
